import React, { useEffect, useState } from "react";
import { Droppable } from "react-beautiful-dnd";
import styled, { css, keyframes } from "styled-components";
import HabibProgressCard from "./HabibProgressCard";

// Slide fade animation
const fadeInSlideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  transition: box-shadow 0.3s ease;
  min-height: 800px;
  ${(props) =>
    props.animate &&
    css`
      animation: ${fadeInSlideUp} 0.5s ease-out;
    `}

  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  }
`;

const TaskList = styled.div`
  padding: 15px;
  background-color: ${(props) =>
    props.isDraggingOver ? "#e0f7f4" : "#fcf8f8ff"};
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  transition: background-color 0.2s ease;
  display: flex;
  flex-direction: column;
  min-height: 700px;
  gap: 10px;
`;

const ProgressColumn = ({
  title,
  task,
  id,
  onComment,
  onUpdateNisabClick,
  onUpdateAssociateMemberClick,
  onMoveMemberClick,
  viewComments,
  progress,
  onchangestatus,
}) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <Container animate={animate}>
      <Droppable droppableId={id}>
        {(provided, snapshot) => (
          <TaskList
            ref={provided.innerRef}
            {...provided.droppableProps}
            isDraggingOver={snapshot.isDraggingOver}
          >
            {task.map((taskItem, index) => (
              <HabibProgressCard
                key={taskItem.id}
                task={taskItem}
                index={index}
                onComment={onComment}
                onUpdateNisabClick={onUpdateNisabClick}
                onUpdateAssociateMemberClick={onUpdateAssociateMemberClick}
                onMoveMemberClick={onMoveMemberClick}
                viewComments={viewComments}
                progress={progress}
                onchangestatus={onchangestatus}
              />
            ))}
            {provided.placeholder}
          </TaskList>
        )}
      </Droppable>
    </Container>
  );
};

export default ProgressColumn;
